import { sendLogin } from '~/composables/useGtmEvents'

export default function useAuth() {
  const router = useRouter()
  const localePath = useLocalePath()
  const isAuthenticated: Ref<boolean> = useState('isAuthenticated', () => false)
  const promises = ref<Promise<any>[]>([])

  const { fetchProfile, cleanProfile, user } = useAccount()

  async function login(email: string, password: string) {
    const promise = $fetch('/api/auth/login/', {
      method: 'POST',
      body: { email, password },
    })

    promises.value.push(promise)

    await promise

    await fetchProfile()
    sendLogin('email', user.value?.data?.id || null)
    isAuthenticated.value = true
  }

  async function verifyToken(redirect: boolean = true) {
    const response = $fetch('/api/auth/verify/', {
      method: 'GET',
    })

    promises.value.push(response)

    const responseData = await response

    isAuthenticated.value = responseData.authenticated

    if (responseData.authenticated) {
      await fetchProfile()
    } else {
      logout(redirect)
    }
  }

  // Separate function for middleware that doesn't auto-redirect
  async function checkAuthStatus() {
    const response = $fetch('/api/auth/verify/', {
      method: 'GET',
    })

    promises.value.push(response)

    const responseData = await response

    isAuthenticated.value = responseData.authenticated

    if (responseData.authenticated) {
      await fetchProfile()
    } else {
      // Only clean state, don't redirect
      isAuthenticated.value = false
      cleanProfile()
    }

    return responseData.authenticated
  }

  async function logout(redirect: boolean = true) {
    const response = $fetch('/api/auth/logout/', { method: 'POST' })

    promises.value.push(response)

    await response

    isAuthenticated.value = false
    cleanProfile()
    if (redirect) {
      router.push(localePath('/login'))
    }
  }

  return {
    isAuthenticated,
    promises,
    login,
    logout,
    verifyToken,
    checkAuthStatus,
  }
}
